<template>
    <button class="tooltip-btn" type="button" @click="openToolTip">
        <i class="material-icons text-lg">help_outline</i>
    </button>

    <ContentModal v-model="showToolTip" :showClose="false">
        <template #header>
            <p class="modal-heading d-flex align-items-center gap-2 fs-5 m-0"
                style="font-weight: 600; color: var(--bs-info);">
                <i class="material-icons info-icon">info</i>
                {{header}}
            </p>
        </template>
        <template #default>
            <p class=" pl-4" style="font-weight: 600; margin: 0 0 5px 0;">{{ heading }}</p>
            <p class="m-0 pl-4" style="font-weight: 400;">{{ paragraph }}</p>
        </template>
    </ContentModal>
</template>

<script setup>
import { ref } from "vue";
import ContentModal from "@/components/Modal/ContentModal.vue";

defineProps({
    header: {
        type: String,
        default: "Info",
    },
    heading: {
        type: String,
        required: true,
    },
    paragraph: {
        type: String,
        required: true,
        default: "Test tool tip",
    },
});

const showToolTip = ref(false);

const openToolTip = () => {
    showToolTip.value = true;
};
</script>

<style scoped>
.tooltip-btn {
    border: none;
    background: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--bs-info);
}

.tooltip-btn:hover {
    transform: scale(1.01);
}
</style>
